<template>
    <div ref="selectWrapper"
         :class="['select-body', 'relative', { 'w-full': public }]"
         :id="'sw-' + component.component + '-' + id">
        <JetLabel v-if="component.attributes.label" class="sw-mb-1 sw-mt-1" :value="component.attributes.label"></JetLabel>

        <div @click="toggleDropdown"
             class="form-input w-full rounded-md shadow-sm cursor-pointer flex justify-between items-center px-3 py-2">
            <span v-if="selectedOptions.length">{{ selectedOptions.join(', ') }}</span>
            <span v-else class="text-gray-400">Bitte auswählen</span>
            <img src="/images/arrow-down.svg"
                 alt="arrow-down"
                 class="arrow-down" />
        </div>

        <div v-if="dropdownOpen" class="absolute z-50 mt-1 left-0 form-input w-full max-w-full rounded-md shadow-sm cursor-pointer">
            <label
                v-for="(option, index) in options"
                :key="index"
                class="py-2 hover:bg-gray-100 flex justify-between items-center cursor-pointer"
            >
                <span class="text-sm text-gray-700 mr-2">{{ option }}</span>
                <input
                    type="checkbox"
                    :id="'option-' + index"
                    :value="option"
                    v-model="selectedOptions"
                    class="form-checkbox sw-checkbox"
                />
            </label>
        </div>
    </div>
</template>

<script>
import JetLabel from "@/Jetstream/Label.vue";

export default {
    name: "Select" ,
    components: {JetLabel},
    props:{
        edit: Boolean,
        id: String,
        component: {
            type:Object,
            required:true
        },
        public: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            selectedOptions: [],
            dropdownOpen: false
        }
    },
    computed: {
        requiredSelect: {
            get(){
                return this.component.attributes.required === '1' || this.component.attributes.required === true;
            },
            set(value) {
                this.component.attributes.required = value;
            }
        },
        options() {
            const optionsString = this.component.attributes.selectOptions || '';
            return optionsString.split('|').map(option => option.trim()).filter(option => option !== '');
        }
    },
    created() {
        const value = this.component.attributes.value || '';
        this.selectedOptions = value.split(',').map(s => s.trim()).filter(Boolean);
    },
    mounted() {
        document.addEventListener('click', this.handleClickOutside);
    },
    beforeUnmount() {
        document.removeEventListener('click', this.handleClickOutside);
    },
    methods: {
        toggleDropdown() {
            this.dropdownOpen = !this.dropdownOpen;
        },
        toggleOption(option) {
            const index = this.selectedOptions.indexOf(option);
            if (index === -1) {
                this.selectedOptions.push(option);
            } else {
                this.selectedOptions.splice(index, 1);
            }
        },
        handleClickOutside(event) {
            const dropdown = this.$refs.selectWrapper;
            if (dropdown && !dropdown.contains(event.target)) {
                this.dropdownOpen = false;
            }
        }
    },
    watch: {
        selectedOptions(newValue) {
            const commaSeparated = newValue.join(', ');
            this.$emit('updateContact', {
                id: this.component.id,
                value: commaSeparated
            });
        }
    }
}
</script>

<style scoped>

</style>
